import * as _ from 'underscore'
import { IconSet } from './iconSet'

export interface IIcons {
	Add: string;
	AddFilter: string;
	Cancel: string;
	Delete: string;
	Edit: string;
	New: string;
	Ok: string;
	Submit: string; 
}; 

export var Icons: IIcons = _.extend({}, Icons, {
	Add: IconSet.Add,
	AddFilter: IconSet.Add,
	Cancel: IconSet.Cancel,
	Delete: IconSet.Delete,
	Edit: IconSet.Edit,
	New: IconSet.New,
	Ok: IconSet.Ok,
	Submit: IconSet.Save 
});